"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultThumbnailApiParams = void 0;
exports.defaultThumbnailApiParams = {
    quality: 100
};
